// extracted by mini-css-extract-plugin
export default {"modCarpet":"FlooringMenu_modCarpet__p9Y2+","mainMenu":"FlooringMenu_mainMenu__ztQgE","activeMenuTab":"FlooringMenu_activeMenuTab__y6j91"};